<template>
    <div class="mobile-bottom-bar">
      <div class="item" v-if="user">
        <router-link :to="{ name : 'User', params:{ section: 'deposit' } }" >
          <div class="icon">
            <img src="@/assets/images/common/icons/deposit.gif" width="18">
          </div>
          <p>Para Yatır <br> <small>{{ user.balance }} {{ user.currency }}</small></p>
        </router-link>
      </div>
      <div class="item" v-if="!user">
        <router-link :to="{ name : 'Login' }" >
          <div class="icon">
            <img src="@/assets/images/avatar.jpg" style="border-radius: 100%;" width="18">
          </div>
          <p>Giriş Yap</p>
        </router-link>
      </div>
      <div class="item">
        <router-link :to="{ name : 'Slot' }" >
          <div class="icon">
            <img src="@/assets/images/common/icons/slot.png" width="18">
          </div>
          <p>Slot</p>
        </router-link>
      </div>
      <div class="item" @click="collapseBottom = !collapseBottom; $parent.activePanel = 'left-panel'">
        <a href="javascript:;"  class="contact" @click="">
           <img src="@/assets/images/bull-icon.png" width="30" style="margin-bottom: 5px;">
            <p>MENU</p>
        </a>
      </div>
      <div class="item">
        <router-link :to="{ name : 'Casino' }" >
          <div class="icon">
            <img src="@/assets/images/common/icons/casino.png" width="18">
          </div>
          <p>Casino</p>
        </router-link>
      </div>
      <div class="item">
        <a href="javascript:;" @click="livechat()">
          <img src="@/assets/images/common/icons/chat.png" width="18">
          <p>Canlı Destek</p>
        </a>
      </div>
    </div>
      
  
</template>

<script>
  import RequestPage from './Header/Request'
  export default{
		data(){
			return{
                type: '',
                bonus_modal: false,
                collapseBottom: false,
			}
		},
    methods:{
        livechat(){
          const campaignId = '919adaf9-cecd-4855-878b-736b1150947a';
          Comm100API.do('livechat.button.click', campaignId);
        },
        openBetslip(){
          if(this.$route.name == 'Sportsbook' || this.$route.name == 'Live'){
            this.$store.dispatch('BetSlipToggle', true);
          }else{
            this.$router.replace({name: 'Sportsbook'});
            setTimeout(()=>{
              this.$store.dispatch('BetSlipToggle', true);
            },100);
          }
        }
    },
		components:{
			RequestPage
		},
    computed:{
        configSpesific(){ 
          return this.$store.getters['special/getConfigSpesific']
        },
        specialMenu(){
          return this.$store.getters['special/getMenu']
        },
        social(){
          return this.$store.getters.getClientContent;
        },
        user(){
          return this.$user();
        },
        url(){
          let url = this.$store.getters['special/bonusUrl']
          if(this.$auth()){
            url = url + this.user.username;
          }
          return url
        },
    }
  }
</script>

<style lang="scss">
  #app.mobile .mobile-bottom-bar .item a.contact {
      color: #ffffff !important;
      background: var(--c);
      padding: 7px 0;
      width: 70px;
      position: relative;
      border-radius: 10px;
  }
  .bottom-collapse{
    position: absolute;
    width: 100%;
    border-top: 1px solid var(--c);
    background: var(--client-header);
    display: flex;
    flex-direction: row;
    bottom: 65px;
    padding: 5px;
    left: 0px;
    a{
      width: 100% !important;
      display: flex;
      align-items: center;
      justify-content: center;
      background: var(--c);
      margin: 5px;
      top: 0;
      position: relative;
      border-radius: 5px;
      opacity: 0;
      &.telegram{background: #0088cc;}
      &.whatsapp{background: #0ab94b;}
      svg{
        height: 20px;
      }
      &:nth-child(2){
        animation-delay: 0.2s !important;
      }
      animation: fadeCollapse 0.2s alternate forwards;
      @keyframes fadeCollapse{
        from{
          opacity: 0;
          top: -40px !important;
        }
        to{
          opacity: 1;
          top: 0px !important;
        }
      }
      svg{
        margin: 0 5px;
      }
    }
  }

</style>